import {
  Box,
  Input,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  IconChecked,
} from "components/icons/Icons";
import {useState} from "react";
import { supportLanguages } from "views/customer/main/variables/data";

export default function LanguageMenuElement(props: {
  rawIndex: number;
  value: string[];
  handleChange: Function;
}) {
  const {rawIndex, value, handleChange} = props;
  const [targetLangQuery, setTargetLangQuery] = useState("");
  const targetLanguage = value;
  const onChangeLanguages = (e: any) => {
    if( !targetLanguage.includes(e) ) {
      handleChange(rawIndex, [...targetLanguage, e]);
    } else {
      handleChange(rawIndex, targetLanguage.filter( (language: string) => language !== e));
    }
  }
  
  return (
    <Menu closeOnSelect={false}>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        sx={{
          height: "48px",
          padding: "15px 16px",
          borderRadius: "100px",
          background: "#FFF",
          border: "1px solid #E0E0E0",
          width: "100%",
          textAlign: "left",
          color:
            targetLanguage.length > 0
              ? "#000"
              : "rgba(0,0,0,0.3)",
          fontSize: "15px",
          fontWeight: "400",
          lineHeight: "normal",
          fontFamily: "Inter",
          "&[data-active]": {
            backgroundColor: "#EFEFEF",
          },
        }}
      >
        <Box
          width="100%"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {targetLanguage.length > 0
            ? targetLanguage?.join(", ")
            : "Select Language(s)"}
        </Box>
      </MenuButton>
      
      <MenuList maxH="300px" overflow="auto" width="100%">
        <Box paddingY={2} px={1} boxSizing="border-box" bgColor="#F2F2F2">
          <Input
            autoFocus={true}
            tabIndex={1}
            placeholder="Enter the keyword.."
            borderRadius="5px"
            sx={{
              background: "#FFF !important",
              padding: "2px 5px !important",
              height: "36px",
              fontSize: "14px",
              lineHeight: "120%",
            }}
            _placeholder={{
              fontSize: "14px",
            }}
            value={targetLangQuery}
            onChange={(e) => {
              setTargetLangQuery(e.target.value);
            }}
          />
        </Box>
        {(targetLangQuery?.length < 1
          ? supportLanguages
          : supportLanguages?.filter((it) =>
              it.toLowerCase()?.includes(targetLangQuery.toLowerCase())
            )
        ).map((it: string, index: number) => (
          <MenuItem
            sx={{
              px: "5px",
              background: targetLanguage?.includes(it)
                ? "#2F80ED"
                : "#FFF",
              color: targetLanguage?.includes(it)
                ? "#FFF"
                : "#000",
            }}
            key={index}
            onClick={() => onChangeLanguages(it)}
          >
            <IconBox
              w="20px"
              h="20px"
              sx={{
                opacity: targetLanguage?.includes(it)
                  ? 1
                  : 0,
              }}
              icon={
                <IconChecked
                  sx={{
                    path: {
                      fill: "#FFF",
                    },
                  }}
                />
              }
            />
            {it}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}